import React from "react"
import {
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
} from "@material-ui/core"
import Blockquote from "./blockquote"
import { Link } from "gatsby-theme-material-ui"
import MDXImage from "./MDXImage.js"
import { CodeBlock, CodeInline } from "./MDXCode"

const components = {
  p: props => <Typography paragraph {...props} />,
  h1: props => <Typography variant="h1" {...props} gutterBottom />,
  h2: props => <Typography variant="h2" {...props} gutterBottom />,
  h3: props => <Typography variant="h3" {...props} gutterBottom />,
  h4: props => <Typography variant="h4" {...props} gutterBottom />,
  h5: props => <Typography variant="h5" {...props} gutterBottom />,
  h6: props => <Typography variant="h6" {...props} gutterBottom />,
  a: props => <Link to={props.href} {...props} />,

  blockquote: props => <Blockquote {...props} />,
  li: props => <Typography component="li" {...props} />,
  table: props => (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="a dense table" {...props} />
    </TableContainer>
  ),
  thead: props => <TableHead {...props} />,
  tr: props => <TableRow {...props} />,
  th: props => <TableCell component="th" children={props.children} />,
  td: props => <TableCell component="td" children={props.children} />,
  tbody: props => <TableBody {...props} />,
  //code: CodeBlock,
  "p.inlineCode": props => <CodeInline {...props} />,
  pre: ({ children: { props } }) => {
    if (props.mdxType === "code") {
      return (
        <CodeBlock
          codeString={props.children.trim()}
          language={props.className && props.className.replace("language-", "")}
          {...props}
        />
      )
    }
  },

  MDXImage: props => <MDXImage {...props} />,
}

export default components
